import { render } from "./SignupForm.vue?vue&type=template&id=8d7e58ae&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=8d7e58ae&lang=scss&scoped=true"
import "./SignupForm.vue?vue&type=style&index=1&id=8d7e58ae&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7e58ae"]])

export default __exports__